import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
  addressBook: [],
  clientEmailAddress: '',
  prePopulatedEmails: [],
  subject: ''
};

const getters = {
  getAddressBook: (state) => state.addressBook,
  getClientEmailAddress: (state) => state.clientEmailAddress,
  getPrePopulatedEmails: (state) => state.prePopulatedEmails,
  getSubject: (state) => state.subject

};

const actions = {
    async getClientEmailAddress(context, data) {
      await axios.post(`${backendUrl()}/getClientEmailAddress`, {
          userLevel: data.userLevel,
          docId: data.docId,
          sessionToken: vuecookie.get('token'),
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setClientEmailAddress', response.data.clientEmailAddress)
          context.commit('setPrePopulatedEmails', response.data.prePopulatedEmails)
          context.commit('setSubject', response.data.subject)
      })
  },
  async searchAddressBook(context, data) {
      await axios.post(`${backendUrl()}/searchAddressBook`,
      {
          sessionToken: vuecookie.get('token'),
          filter: data.filter,
          userLevel: data.userLevel,
          docId: data.docId,
          type: data.type
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setAddressBook', response.data)
      })
  },
  async addToAddressBook(context, data) {
      await axios.post(`${backendUrl()}/addToAddressBook`,
      {
          sessionToken: vuecookie.get('token'),
          newContact: data.newContact
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
        if(response.data.status != 'error') {
          context.dispatch('getAddressBook')
        }
      })
  }
};

const mutations = {
  setAddressBook: (state, addressBook) => (state.addressBook = addressBook),
  setClientEmailAddress: (state, emailAddress) => (state.clientEmailAddress = emailAddress),
  setPrePopulatedEmails: (state, prePopulatedEmails) => (state.prePopulatedEmails = prePopulatedEmails),
  setSubject: (state, subject) => (state.subject = subject),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
